import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

createCycles();
runPageIn();
runMount();

import { GhostPosts } from "@/modules/ghost-posts";
import { TextAnimations } from "@/modules/text-animations";
import { CoinsAnimation } from "@/modules/coins-animation";

const ghostPosts = new GhostPosts();
ghostPosts.init();
const textAnimations = new TextAnimations();
textAnimations.init();
const footerCoins = new CoinsAnimation('riveFooter', 'footerSection', -0.8, "top bottom", "bottom 20%")
footerCoins.init()


history.scrollRestoration = "manual";
window.scrollTo(0, 0);